// import React, { useState } from "react";
// import Colors from "../../Constants/Colors";
// const RejectModal = ({
//   isOpen,
//   onClose,
//   onSubmit,
//   title = "Rejection Comment",
//   placeholder = "Enter rejection comments...",
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   errorImg,
// }) => {
//   const [tempComment, setTempComment] = useState("");

//   if (!isOpen) return null;

//   const handleSubmit = () => {
//     if (!tempComment.trim()) {
//       if (setMessageBox && setIsMessageBoxVisible) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Please enter comment</span>
//             </div>
//           </div>
//         );
//         if (setActiveImg && errorImg) {
//           setActiveImg(errorImg);
//         }
//       }
//       return;
//     }
//     onSubmit(tempComment);
//     setTempComment("");
//   };

//   return (
//     <div
//       className="modal-overlay"
//       style={{
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         zIndex: 50,
//         color: `${Colors.color1}`,
//       }}
//     >
//       <div
//         className="modal-content"
//         style={{
//           backgroundColor: "white",
//           padding: "20px",
//           borderRadius: "8px",
//           width: "500px",
//         }}
//       >
//         <h2 style={{ marginBottom: "15px" }}>{title}</h2>
//         <textarea
//           value={tempComment}
//           onChange={(e) => setTempComment(e.target.value)}
//           placeholder={placeholder}
//           style={{
//             width: "100%",
//             minHeight: "100px",
//             padding: "10px",
//             marginBottom: "15px",
//             borderRadius: "4px",
//             border: "1px solid #ccc",
//             resize: "vertical",
//           }}
//         />

//         <button
//           className="testreportcard-cancel-btn"
//           onClick={() => {
//             setTempComment("");
//             onClose();
//           }}
//         >
//           Cancel
//         </button>
//         <button className="testreportcard-create-btn" onClick={handleSubmit}>
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// };

// export default RejectModal;















import React, { useState, useEffect } from "react";
import Colors from "../../Constants/Colors";

const RejectModal = ({
  isOpen,
  onClose,
  onSubmit,
  title = "Rejection Comment",
  placeholder = "Enter rejection comments...",
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  errorImg,
}) => {
  const [tempComment, setTempComment] = useState("");
  const [isClosing, setIsClosing] = useState(false);

  // Reset state when modal opens
  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
      setTempComment("");
    }
  }, [isOpen]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setTempComment("");
      onClose();
    }, 200);
  };

  const handleSubmit = () => {
    if (!tempComment.trim()) {
      if (setMessageBox && setIsMessageBoxVisible) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please enter a comment</span>
            </div>
          </div>
        );
        if (setActiveImg && errorImg) {
          setActiveImg(errorImg);
        }
      }
      return;
    }
    onSubmit(tempComment);
    setTempComment("");
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  // Handle Escape key press
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      handleClose();
    }
  };

  return (
    <div
      className="modal-overlay"
      onClick={handleOverlayClick}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: isClosing ? "rgba(0, 0, 0, 0)" : "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        transition: "background-color 0.2s ease-out",
      }}
    >
      <div
        // className="modal-contents"
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          width: "min(500px, 90vw)",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          transform: isClosing ? "scale(0.95)" : "scale(1)",
          opacity: isClosing ? 0 : 1,
          transition: "transform 0.2s ease-out, opacity 0.2s ease-out",
          overflow: "hidden",
          padding: "0px"
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 24px",
            borderBottom: "1px solid #e5e7eb",
            backgroundColor: "#f9fafb",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "18px",
              fontWeight: 600,
              color: Colors.color1 || "#1f2937",
            }}
          >
            {title}
          </h2>
          <button
            onClick={handleClose}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: "8px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "background-color 0.15s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e5e7eb")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}
            aria-label="Close modal"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#6b7280"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: "24px" }}>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: 500,
              color: "#374151",
              marginBottom: "8px",
            }}
          >
            Reason <span style={{ color: "#ef4444" }}>*</span>
          </label>
          <textarea
            value={tempComment}
            onChange={(e) => setTempComment(e.target.value)}
            placeholder={placeholder}
            autoFocus
            style={{
              width: "100%",
              minHeight: "120px",
              padding: "12px 14px",
              borderRadius: "8px",
              border: "1px solid #d1d5db",
              fontSize: "14px",
              lineHeight: "1.5",
              resize: "vertical",
              transition: "border-color 0.15s ease, box-shadow 0.15s ease",
              outline: "none",
              fontFamily: "inherit",
              boxSizing: "border-box",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = Colors.color1 || "#3b82f6";
              e.target.style.boxShadow = `0 0 0 3px ${Colors.color1 || "#3b82f6"}20`;
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "#d1d5db";
              e.target.style.boxShadow = "none";
            }}
          />
          <p
            style={{
              margin: "8px 0 0 0",
              fontSize: "12px",
              color: "#6b7280",
            }}
          >
            Please provide a clear reason for this action.
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            padding: "16px 24px",
            borderTop: "1px solid #e5e7eb",
            backgroundColor: "#f9fafb",
          }}
        >
          <button
            className="testreportcard-cancel-btn"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="testreportcard-create-btn"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
